var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"text-center padding-3 bg-white card-border-color",staticStyle:{"line-height":"33px"}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }